export default __webpack_public_path__ + "static/media/bg-rates.2c825c62.png";